"use client"

import DashboardLayout from "@/views/dashboard/DashboardLayout"
import GraduateLessons from "./GraduateLessons"


export default function GraduateLessonsPage() {
  return (
    <DashboardLayout>
      <GraduateLessons />
    </DashboardLayout>
  )
}
